import { render, staticRenderFns } from "./SolanaWallet.vue?vue&type=template&id=b1d89a78&scoped=true"
import script from "./SolanaWallet.vue?vue&type=script&lang=js"
export * from "./SolanaWallet.vue?vue&type=script&lang=js"
import style0 from "./SolanaWallet.vue?vue&type=style&index=0&id=b1d89a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d89a78",
  null
  
)

export default component.exports